// Automatically updated by `npm run release`
export default '38.0.0';
